import React, { useState, useEffect } from 'react';
import Add from '../images/icons/add.png';
import Close from '../images/icons/close-sm.png';
import Editicon from '../images/icons/edit-bg.png';
import Delete from '../images/icons/delete_btn.png';
import Pagination from 'react-js-pagination';
import $ from "jquery";
import { callingAPI, callingPostAPI, callingGetAPI } from '../config';
import Tick from '../images/icons/tick.png';
import InActive from '../images/icons/close.png';
import NoData from '../Common/noDataFound';
import Loader from '../Common/loader';
import zIndex from '@material-ui/core/styles/zIndex';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AddLabWork() {
    const [dataFlag, setDataFlag] = useState(false);
    const [saveFlag, setSaveFlag] = useState(false);
    const [addLabWork, setAddLabWork] = useState([])
    const [labName, setLabName] = useState("");
    const [searchType, setSearchType] = useState(0);
        const [isEnabled, setIsEnabled] = useState(true);
        const [searchStatusType, setSearchStatusType] = useState(0);
        const [searchPerformed, setSearchPerformed] = useState(false);
        const [treatmentproclistdata, setTreatmentProcListData] = useState([]);
    
    const [labNameSearch, setLabNameSearch] = useState("");
    const [categoryValues, setCategoryValues] = useState([]);
    const [labCategoryId, setlabCategoryId] = useState('0');
    const [dentalLabWorkNameId, setDentalLabWorkNameId] = useState("");
    const [count, setCount] = useState('');
    const [activePage, setActivePage] = useState(parseInt(window.sessionStorage.getItem('labTestactivePage')));
    const [pageOffset, setPageOffset] = useState(0);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [workTypeValues, setWorkTypeValues] = useState([]);
    const [selectedWorkType, setSelectedWorkType] = useState([]);
    const [selectedWorkTypeValue, setSelectedWorkTypeValue] = useState("");
    const [workTypeId, setWorkTypeId] = useState(0);
    const [workTypeName, setWorkTypeName] = useState("");
    const [searchValue, setSearchValue] = useState('');
    const [pageCount, setPageCount] = useState('');
    const [flag, setFlag] = useState(0);

    const statusChange = (id, status) => {
        var x = false;
        if (status === true) {
            x = window.confirm('Do you want to Enable this?');
        } else {
            x = window.confirm('Do you want to Disable this?');
        }
        if (x === true) {
            const satusData = {
                dentalLabWorkNameId: id,
                dentalLabWorkNameStatus: status == false ? false : true,

            };

            callingAPI('commonUserFunctions/changeStatusDentalLabWorkNames', satusData).then((data) => {
                if (data.data.success === '1') {
                    toast.success('Status Changed Successfully');
                    labworkList();
                }
                if (data.data.success === '0') {
                    toast.error(data.data.errorMessage);
                }
            });
        }
    };

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        var offset;
        var max;
        if (pageNumber === '1') {
            offset = '0';
            max = process.env.REACT_APP_PAGINATION_COUNT;
        } else {
            offset = parseInt(pageNumber - 1) * process.env.REACT_APP_PAGINATION_COUNT;
            max = process.env.REACT_APP_PAGINATION_COUNT;
        }
        // setActivePage(pageNumber);
        // setPageOffset(offset);
        window.sessionStorage.setItem("labTestactivePage", pageNumber)
        window.sessionStorage.setItem('labTestoffset', offset)
        const finalSearchStat = searchStatusType === 0
        ? null
        : searchStatusType === "true"
          ? 1
          : 0;
        const PostData = {
            "dentalLabWorkNameId": "",
            "dentalLabWorkName": labNameSearch === "" ? "" : labNameSearch,
            "dentalLabWorkType": "",
            "dentalLabWorkNameStatus": "",
            "hospitalId": localStorage.getItem("hospitalId"),
            "offset": offset,
            "max": max,
            "status": finalSearchStat
        };
        callingAPI('commonUserFunctions/getDentalLabWorkNames', PostData).then((response) => {

            if (response.data.success === '1') {
                setDataFlag(true);
                setAddLabWork(response.data.result.dentalLabWorkNames);
                setCount(response.data.result.totalCount);
            }
            else {
                setDataFlag(true);
                setAddLabWork([]);
                setCount("");
            }
        })
            .catch();
    };
    const categoryChange = (event) => {
        const selectedCategoryId = event.target.value;
        const selectedWorkType = workTypeValues.find((item) => item.id === parseInt(selectedCategoryId));

        // Check if a work type is found
        if (selectedWorkType) {
            const selectedWorkTypeName = selectedWorkType.name;
            console.log("Selected Category ID:", selectedCategoryId);
            console.log("Selected Category Name:", selectedWorkTypeName);

            setlabCategoryId(selectedCategoryId);
            setWorkTypeId(selectedCategoryId);
            setWorkTypeName(selectedWorkTypeName);
        } else {
            console.log("No work type found for the selected category ID:", selectedCategoryId);
        }
    };

    const getWorkNameList = (offset, searchVal, searchTyp, searchStat) => {
        console.log('searchStat11', searchStat);
        const updatedSearchTyp = searchStat !== 0 ? 3 : searchTyp;
        const finalSearchStat = searchStat === 0
        ? null
        : searchStat === "true"
          ? 1
          : 0;
              const PostData = {
                "dentalLabWorkNameId": "",
                "dentalLabWorkName": labNameSearch === "" ? "" : labNameSearch,
                "dentalLabWorkType": "",
                "dentalLabWorkNameStatus": "",
                "hospitalId": localStorage.getItem("hospitalId"),
                "offset": offset,
                "max": process.env.REACT_APP_PAGINATION_COUN,
                searchKeyword: searchVal,
                selectDropdownSearchType: updatedSearchTyp,
                status: finalSearchStat
            };
    
            callingAPI('commonUserFunctions/getDentalLabWorkNames', PostData).then((response) => {
                if (response.data.success === '1') {
                    setDataFlag(true);
                    setAddLabWork(response.data.result.dentalLabWorkNames);
                    setCount(response.data.result.totalCount);
                }
                else {
                    setDataFlag(true);
                    setAddLabWork([]);
                    setCount("");
                }
            });
        };

    const labWorkAddSave = () => {
        setIsButtonDisabled(true);
        let flags = true;
        var toastShown = false;
        if (document.getElementById('accountHead').value == '0') {
            if (!toastShown) {
                toast.error('Select Work Type');
                document.getElementById('accountHead').focus();
                setIsButtonDisabled(false);
                flags = false;
                toastShown = true;
                setTimeout(() => {
                    toastShown = false;
                }, 3000);
            }
            return;
        }
        else if (!labName) {
            if (!toastShown) {
                toast.error('Enter New Work Name');
                document.getElementById('labName').focus();
                setIsButtonDisabled(false);
                flags = false;
                toastShown = true;
                setTimeout(() => {
                    toastShown = false;
                }, 3000);
            }
            return;
        }
        else {
            if (flags === true) {

                var a = selectedWorkType
                let postData = {
                    "dentalLabWorkNameId": dentalLabWorkNameId,
                    "dentalLabWorkName": labName,
                    "dentalLabWorkTypeId": workTypeId,
                    "workType": workTypeName,
                    "dentalLabWorkNameStatus": true,
                    "hospitalId": localStorage.getItem("hospitalId"),
                    "isActive": true
                }
                console.log("postData", postData)
                callingAPI('commonUserFunctions/saveDentalLabWorkNames', postData).then((response) => {

                    if (response.data.success === "1") {
                        labworkList();
                        setSelectedWorkType([])
                        // setSelectedWorkTypeValue("")
                        setlabCategoryId(0);
                        setWorkTypeId(0);
                        setWorkTypeName("");
                        setLabName("")
                        closePopup();
                        setDentalLabWorkNameId("")
                        if (dentalLabWorkNameId === "") {
                            toast.success("Added Successfully");
                            setIsButtonDisabled(false);
                        }
                        else {
                            toast.success("Updated Successfully");
                            setIsButtonDisabled(false);
                        }

                    }
                    else {
                        toast.error(response.data.errorMessage);
                    }
                })
            }
        }
    }

    const searchTypeOnChenge = (event) => {
		if (event.target.value == 0) {
			setIsEnabled(true);
			setSearchType(event.target.value);
			setSearchValue('');

		} else {
			setSearchType(event.target.value);
			setIsEnabled(false);
		}

		if (document.getElementById('searchType').value !== '') {
			document.getElementById('searchText').disabled = false;
			document.getElementById('searchText').focus();
		} else {
			document.getElementById('searchText').disabled = true;
		}
		document.getElementById('searchText').value = '';

	};

    const enterKey = (e) => {
        if (e.key === 'Enter') {
            searchValueChange();
        }
    }

    const searchValueChange = () => {
        const PostData = {
            "dentalLabWorkNameId": "",
            "dentalLabWorkName": labNameSearch === "" ? "" : labNameSearch,
            "dentalLabWorkType": "",
            "dentalLabWorkNameStatus": "",
            "hospitalId": localStorage.getItem("hospitalId"),
            "offset": 0,
            "max": 10
        };
        callingAPI('commonUserFunctions/getDentalLabWorkNames', PostData).then((response) => {


            if (response.data.success === '1') {
                setDataFlag(true);
                window.sessionStorage.setItem("labTestactivePage", 1)
                window.sessionStorage.setItem('labTestoffset', 0)
                setAddLabWork(response.data.result.dentalLabWorkNames);
                setCount(response.data.result.totalCount);


            }
            else {
                setDataFlag(true);
                setAddLabWork([]);
                setCount("");
            }
        })
            .catch();

    }

    const labworkList = () => {
        const PostData = {
            "dentalLabWorkNameId": "",
            "dentalLabWorkName": "",
            "dentalLabWorkType": "",
            "dentalLabWorkNameStatus": "",
            "hospitalId": localStorage.getItem("hospitalId"),
            "offset": window.sessionStorage.getItem("labTestoffset"),
            "max": 10
        };
        callingAPI('commonUserFunctions/getDentalLabWorkNames', PostData).then((response) => {


            if (response.data.success === '1') {
                setDataFlag(true);
                setAddLabWork(response.data.result.dentalLabWorkNames);
                setCount(response.data.result.totalCount);


            }
            else {
                setDataFlag(true);
                setAddLabWork([]);
                setCount("");
            }
        })
            .catch();
    }
    const addLabWorkClick = () => {
        $("#plpopup1").css("visibility", "visible");
        $("#plpopup1").css("opacity", "1");
        setSelectedWorkType("")
        //  setSelectedWorkTypeValue("")
        setLabName("")
        setlabCategoryId(0);
        setWorkTypeId(0);
        setWorkTypeName("");
        setDentalLabWorkNameId("")
    }
    const closePopup = () => {
        setSaveFlag(false)
        $("#plpopup1").css("visibility", "hidden");
        $("#plpopup1").css("opacity", "0");
    }
    const editLablist = (data) => {
        setSaveFlag(true)
        $("#plpopup1").css("visibility", "visible");
        $("#plpopup1").css("opacity", "1");
        setLabName(data.dentalLabWorkName);
        setlabCategoryId(data.dentalLabWorkTypeId);
        setSelectedWorkType(data.dentalLabWorkTypeId)
        //  setSelectedWorkTypeValue(data.dentalLabWorkTypeName)
        setDentalLabWorkNameId(data.dentalLabWorkNameId)
        setWorkTypeId(data.dentalLabWorkTypeId)
        setWorkTypeName(data.dentalLabWorkTypeName)


    }

    useEffect(() => {
        const PostData = {};
        callingAPI('commonUserFunctions/getDentalLabWorkTypes', PostData)
            .then((data) => {
                if (data.data.success === '1') {

                    setCategoryValues(data.data.result.dentalLabWorkNames);
                }
                else {
                    setCategoryValues([]);
                }

            })
            .catch();
        labworkList();
        workTypeOnchange();

    }, []);
    const handleKeypress = (event) => {
		if (event.key === 'Enter') {
			searchClickFunction();
		}
	};
    const searchClickFunction = () => {

        console.log('searchType11', searchType);
        console.log('searchValue11', searchValue);
        console.log('searchStatusType11', searchStatusType);
            if (Number(searchType !== 0) && searchValue && searchValue === "") {
                toast.error("Enter search value");
                return;
            }
    
            sessionStorage.setItem("searchValue", searchValue);
            sessionStorage.setItem("searchType", searchType);
            sessionStorage.setItem("searchStatusType", searchStatusType);
            setSearchPerformed(true);
    
            setActivePage(1);
            setPageOffset(0);
            sessionStorage.setItem("pagenumberTreatmentProcedure", 1);
            sessionStorage.setItem("treatmentProcedureOffset", 0);
    
            getWorkNameList(0, searchValue, searchType, searchStatusType);
        };
    
        const clearSearch = () => {
            setSearchValue('');
            setSearchType(0);
            setSearchStatusType(0);
            setSearchPerformed(false);
    
            sessionStorage.removeItem("searchValue");
            sessionStorage.removeItem("searchType");
            sessionStorage.removeItem("searchStatusType");
    
            getWorkNameList(0, '', 0, 0);
        };
        const searchStatusChange = (event) => {
            console.log('event11', event);
            setSearchStatusType(event.target.value);
        };
    
        const searchValueFunction = (event) => {
            setSearchValue(event.target.value);
        };
    const workTypeOnchange = () => {
        // setSelectedWorkTypeValue(e)
        const PostData = {
            "searchInput": "",
            "max": "",
            "offset": "",
            "hospitalId": localStorage.getItem("hospitalId"),
        }
        callingAPI('commonUserFunctions/LabworkTypeList', PostData)
            .then((data) => {
                if (data.data.success === '1') {
                    if (data.data.result.labWorkTypeList.length > 0) {

                        var dataFormat = data.data.result.labWorkTypeList.filter((data) => data.is_active === true)
                        setWorkTypeValues(dataFormat)
                        // if (dataFormat.length > 0) {
                        //     document.getElementById("selectedWorkTypeValue").style.display = "block"
                        // }
                        // else {
                        //     document.getElementById("selectedWorkTypeValue").style.display = "none"
                        // }
                    }
                }
            })
    }
    const selectedWorkTypeOnChange = (e) => {
        setSelectedWorkType(e)
        setSelectedWorkTypeValue(e.name)
        document.getElementById("selectedWorkTypeValue").style.display = "none"

    }

    return (
        <div className="dashboardCover">
            <ToastContainer position="bottom-right" style={{ zIndex: "999999999" }} />
            <div className="row">
                <div className="col-md-10">
                    <div className="dashboardTitle">Work Name</div>
                </div>

                <div className="col-md-2">
                    <div onClick={() => { addLabWorkClick(); }} style={{ color: '#fff', textDecoration: 'none' }}>
                        <span
                            className="dashButtonBorder"
                            style={{ background: '#22a2fd', border: 'none', color: '#fff', padding: "6px 4px", fontSize: "13px" }}
                        >
                            Add New Work Name
                        </span>
                    </div>
                </div>
            </div>
            {count > 10 && (
                <div className="paginationSection">
                    <Pagination
                        // hideNavigation
                        hideDisabled
                        activePage={activePage}
                        itemsCountPerPage={process.env.REACT_APP_PAGINATION_COUNT}
                        totalItemsCount={count}
                        pageRangeDisplayed={process.env.REACT_APP_PAGINATION_RANGE}
                        onChange={handlePageChange}
                    />
                </div>
            )}
            <div className="dashboardContent">
                <div className="reportWrap">
                    {/* <div className="dashboardSearch">
                        <div className="row">
                            <div className="col-md-2 dashboardSearchList">
                                <input
                                    id="labNameSearch"
                                    type="text"
                                    className="inputField"
                                    placeholder='Enter Work Name'
                                    autoComplete="off"
                                    name='labNameSerach'
                                    value={labNameSearch}
                                    onChange={(e) => setLabNameSearch(e.target.value)}
                                />
                            </div>
                            <div className="col-md-2 dashboardSearchList">
                                <span className="dashButtonBorder"
                                    onClick={searchValueChange}
                                    title="Search"
                                    onKeyDown={enterKey}>
                                    Search
                                </span>
                            </div>
                        </div>
                    </div> */}
                    <div className="dashboardSearch">
						<div className="row">
							<div className="col-md-2 dashboardSearchList">
								<select
									className="inputField"
									id="searchType"
									value={searchType}
									onChange={searchTypeOnChenge}
								>
									<option value="0">Select Value</option>
									<option value="1">Work Type</option>
									<option value="2">Work Name</option>
								</select>
							</div>
							<div className="col-md-2 dashboardSearchList">
								{/* <input
									type="text"
									id="searchValue"
									value={searchValue}
									disabled={isEnabled}
									onChange={searchValueFunction}
									className="inputField"
									placeholder="Enter Value"
									style={{ background:searchType === "0" ? "transparent" : "white" }}
								/> */}
								{/* {searchType == "0" ? (
									<input

										type="text"
										className="inputField"
										id="searchText"
										name="searchText"
										value={searchValue}
										disabled={isEnabled}
										onChange={searchValueFunction}
										placeholder="Enter Value"
										style={{ background: "transparent" }}
									/>
								) : ( */}
								<input
									type="text"
									className="inputField"
									id="searchText"
									name="searchText"
									autoComplete='off'
									value={searchValue}
									disabled={isEnabled}
									onKeyPress={handleKeypress}
									onChange={searchValueFunction}
									autofocus="autofocus"
									style={{ background: searchType == "0" ? "transparent" : "white" }}
								/>
								{/* )} */}
							</div>
							<div className="col-md-2 dashboardSearchList">
								<select className="inputField" onKeyPress={handleKeypress} value={searchStatusType} onChange={searchStatusChange}>
									<option value="0">Status</option>
									<option value="true">Active</option>
									<option value="false">Inactive</option>
								</select>
							</div>
							<div className="col-md-2 dashboardSearchList">
								<span className="dashButtonBorder" onClick={searchClickFunction} onKeyPress={handleKeypress} title='Search'>
									Search
								</span>
							</div>
							{searchPerformed && (
								<div className="col-md-2">
									<button className="dashButtonBorder text-danger" onClick={clearSearch}>Clear Search</button>
								</div>
							)}
		
						</div>
					</div>
                    {dataFlag == false ? (
                        <Loader />
                    ) : addLabWork.length > 0 ? (
                        <div className="dashboardtable">
                            <table>
                                <thead>
                                    <th>Work Type</th>
                                    <th>Work Name</th>
                                    <th>Status</th>

                                    <th style={{ width: "10%" }}></th>
                                </thead>
                                {console.log("..............................addLabWork", addLabWork)}
                                <tbody>
                                    {addLabWork.map((data) => (
                                        <tr>
                                            <td className='vertical-middle'>{data.dentalLabWorkTypeName}</td>
                                            <td className='vertical-middle'>{data.dentalLabWorkName}</td>
                                            {data.dentalLabWorkNameStatus === 1 ? (<td className='vertical-middle'>Active</td>) : (<td className='vertical-middle'>Inactive</td>)}
                                            <td className='vertical-middle' style={{ width: "10%" }}>
                                                <img src={Editicon} onClick={() => editLablist(data)} alt="Edit" className='img-fluid' title='Edit' />
                                                {data.dentalLabWorkNameStatus === 1 ? (
                                                    <img
                                                        src={Tick}
                                                        alt="Active"
                                                        className='img-fluid'
                                                        width={20}
                                                        title="Click to Deactivate"
                                                        onClick={() => statusChange(data.dentalLabWorkNameId, false)} />
                                                ) : (
                                                    <img
                                                        src={InActive}
                                                        alt="InActive"
                                                        className='img-fluid'
                                                        width={20}
                                                        title="Click to Activate"
                                                        onClick={() => statusChange(data.dentalLabWorkNameId, true)} />
                                                )}
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            <br />
                        </div>
                    ) : (
                        <p>
                            <NoData />
                        </p>
                    )}
                </div>
            </div>
            {count > 10 && (
                <div className="paginationSection">
                    <Pagination
                        // hideNavigation
                        hideDisabled
                        activePage={activePage}
                        itemsCountPerPage={process.env.REACT_APP_PAGINATION_COUNT}
                        totalItemsCount={count}
                        pageRangeDisplayed={process.env.REACT_APP_PAGINATION_RANGE}
                        onChange={handlePageChange}
                    />
                </div>
            )}

            {/* Popup Begins */}
            <div id="plpopup1" class="ploverlay">
                <div class="plpopup addLabpopup">
                    <h2>Add New Work Name</h2>
                    <div class="close" onClick={closePopup}><span class="popUpClose">x</span></div>
                    <div class="plcontent">
                        <div class="addDataContent">

                            <div class="row">
                                <div className="col-md-3">
                                    <label>Work Type<span class="mandatory">*</span></label>
                                </div>
                                {[console.log("workTypeValues", workTypeValues)]}
                                <div className="col-md-8">
                                    <select name="labCategoryId"
                                        id="accountHead"
                                        className='inputField'
                                        value={labCategoryId}
                                        onChange={categoryChange}
                                    >
                                        <option value="0">Select</option>
                                        {workTypeValues.map((item, idix) => (
                                            <option value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                    {/* <input type="text" id="accountHead" autoComplete='off' className='inputField' value={selectedWorkTypeValue} onChange={(e) => { workTypeOnchange(e.target.value) }} />
                                    <ul className='typeDropdwon-ul' id="selectedWorkTypeValue" style={{ display: "none" }}>
                                        {workTypeValues.map((data) => (
                                            <li onClick={(e) => { selectedWorkTypeOnChange(data) }}>{data.name}</li>))}
                                    </ul> */}
                                </div>
                            </div>
                            <div class="row">
                                <div className="col-md-3">
                                    <label>Work Name<span class="mandatory">*</span></label>
                                </div>
                                <div className="col-md-8">
                                    <input
                                        type="text"
                                        className='inputField'
                                        placeholder="Enter New Work Name"
                                        id="labName"
                                        autoComplete="off"
                                        name='labName'
                                        value={labName}
                                        onChange={(e) => setLabName(e.target.value)} />
                                </div>

                            </div>
                            <div class="summaryBtnDiv">
                                {saveFlag === true ? <button type="submit" class="practiceGreenButton" onClick={labWorkAddSave} style={{ color: '#046b29' }} disabled={isButtonDisabled}>Update</button> :
                                    <button type="submit" class="practiceGreenButton" onClick={labWorkAddSave} style={{ color: '#046b29' }} disabled={isButtonDisabled}>Save</button>}
                                <button type="submit" class="practiceGreenButton" onClick={closePopup} style={{ color: 'red', border: "1px solid red" }}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Popup Ends */}

        </div>
    );
}
export default AddLabWork;
